import comp from "./AttachmentItem";
export default comp;
